module.exports = __webpack_public_path__ + "img/photo-5-1.93460d3e.webp";